/* tslint:disable */
/* eslint-disable */
/**
 * IRM.Web.Customer.API
 * 6d75acac-ec29-43a4-9fe0-2808f10c310c Development
 *
 * The version of the OpenAPI document: 2024.05.17.1151
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration";
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from "axios";
import globalAxios from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "../common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "../base";
// @ts-ignore
import { ApiDeliveryDRAFTPatchRequest } from "../models";
// @ts-ignore
import { ApiDeliverySearchNFilterGridViewPostRequest } from "../models";
// @ts-ignore
import { DeliveryModel } from "../models";
// @ts-ignore
import { DeliveryModelODataResultCollection } from "../models";
// @ts-ignore
import { DocumentFilterDimensions } from "../models";
// @ts-ignore
import { FileUriODataResultCollection } from "../models";
/**
 * DeliveryApi - axios parameter creator
 * @export
 */
export const DeliveryApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {number} docEntry
     * @param {string} dRAFT
     * @param {boolean} [isDraft]
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDeliveryDRAFTDocEntryGet: async (
      docEntry: number,
      dRAFT: string,
      isDraft?: boolean,
      $expand?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'docEntry' is not null or undefined
      assertParamExists("apiDeliveryDRAFTDocEntryGet", "docEntry", docEntry);
      // verify required parameter 'dRAFT' is not null or undefined
      assertParamExists("apiDeliveryDRAFTDocEntryGet", "dRAFT", dRAFT);
      const localVarPath = `/api/Delivery/{DRAFT}/{DocEntry}`
        .replace(`{${"DocEntry"}}`, encodeURIComponent(String(docEntry)))
        .replace(`{${"DRAFT"}}`, encodeURIComponent(String(dRAFT)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Default action to acquire list of documents by IsDraft
     * @param {string} dRAFT
     * @param {boolean} [isDraft]
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDeliveryDRAFTGet: async (
      dRAFT: string,
      isDraft?: boolean,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'dRAFT' is not null or undefined
      assertParamExists("apiDeliveryDRAFTGet", "dRAFT", dRAFT);
      const localVarPath = `/api/Delivery/{DRAFT}`.replace(
        `{${"DRAFT"}}`,
        encodeURIComponent(String(dRAFT))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} docEntry
     * @param {string} dRAFT
     * @param {boolean} [isDraft]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDeliveryDRAFTGetFormIdDocEntryGet: async (
      docEntry: number,
      dRAFT: string,
      isDraft?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'docEntry' is not null or undefined
      assertParamExists(
        "apiDeliveryDRAFTGetFormIdDocEntryGet",
        "docEntry",
        docEntry
      );
      // verify required parameter 'dRAFT' is not null or undefined
      assertParamExists("apiDeliveryDRAFTGetFormIdDocEntryGet", "dRAFT", dRAFT);
      const localVarPath = `/api/Delivery/{DRAFT}/GetFormId/{DocEntry}`
        .replace(`{${"DocEntry"}}`, encodeURIComponent(String(docEntry)))
        .replace(`{${"DRAFT"}}`, encodeURIComponent(String(dRAFT)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary
     * @param {string} dRAFT
     * @param {ApiDeliveryDRAFTPatchRequest} [apiDeliveryDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDeliveryDRAFTPatch: async (
      dRAFT: string,
      apiDeliveryDRAFTPatchRequest?: ApiDeliveryDRAFTPatchRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'dRAFT' is not null or undefined
      assertParamExists("apiDeliveryDRAFTPatch", "dRAFT", dRAFT);
      const localVarPath = `/api/Delivery/{DRAFT}`.replace(
        `{${"DRAFT"}}`,
        encodeURIComponent(String(dRAFT))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      localVarHeaderParameter["Content-Type"] =
        "application/json;odata.metadata=minimal;odata.streaming=true";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiDeliveryDRAFTPatchRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary
     * @param {string} dRAFT
     * @param {ApiDeliveryDRAFTPatchRequest} [apiDeliveryDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDeliveryDRAFTUpdatePost: async (
      dRAFT: string,
      apiDeliveryDRAFTPatchRequest?: ApiDeliveryDRAFTPatchRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'dRAFT' is not null or undefined
      assertParamExists("apiDeliveryDRAFTUpdatePost", "dRAFT", dRAFT);
      const localVarPath = `/api/Delivery/{DRAFT}/Update`.replace(
        `{${"DRAFT"}}`,
        encodeURIComponent(String(dRAFT))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      localVarHeaderParameter["Content-Type"] =
        "application/json;odata.metadata=minimal;odata.streaming=true";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiDeliveryDRAFTPatchRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {number} docEntry
     * @param {boolean} [isDraft]
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDeliveryDocEntryGet: async (
      docEntry: number,
      isDraft?: boolean,
      $expand?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'docEntry' is not null or undefined
      assertParamExists("apiDeliveryDocEntryGet", "docEntry", docEntry);
      const localVarPath = `/api/Delivery/{DocEntry}`.replace(
        `{${"DocEntry"}}`,
        encodeURIComponent(String(docEntry))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Default action to acquire list of documents by IsDraft
     * @param {boolean} [isDraft]
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDeliveryGet: async (
      isDraft?: boolean,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Delivery`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Used to provide valid dimensions of Delivery GridView
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDeliveryGetDocumentFilterDimensionsGet: async (
      $filter?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Delivery/GetDocumentFilterDimensions`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} docEntry
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDeliveryGetFileUriListDocEntryGet: async (
      docEntry: number,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'docEntry' is not null or undefined
      assertParamExists(
        "apiDeliveryGetFileUriListDocEntryGet",
        "docEntry",
        docEntry
      );
      const localVarPath = `/api/Delivery/GetFileUriList/{DocEntry}`.replace(
        `{${"DocEntry"}}`,
        encodeURIComponent(String(docEntry))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} docEntry
     * @param {boolean} [isDraft]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDeliveryGetFormIdDocEntryGet: async (
      docEntry: number,
      isDraft?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'docEntry' is not null or undefined
      assertParamExists(
        "apiDeliveryGetFormIdDocEntryGet",
        "docEntry",
        docEntry
      );
      const localVarPath = `/api/Delivery/GetFormId/{DocEntry}`.replace(
        `{${"DocEntry"}}`,
        encodeURIComponent(String(docEntry))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary
     * @param {ApiDeliveryDRAFTPatchRequest} [apiDeliveryDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDeliveryPatch: async (
      apiDeliveryDRAFTPatchRequest?: ApiDeliveryDRAFTPatchRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Delivery`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      localVarHeaderParameter["Content-Type"] =
        "application/json;odata.metadata=minimal;odata.streaming=true";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiDeliveryDRAFTPatchRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [searchString]
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDeliverySearchContractDetailsGet: async (
      searchString?: string,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Delivery/SearchContractDetails`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (searchString !== undefined) {
        localVarQueryParameter["SearchString"] = searchString;
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [searchString]
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDeliverySearchGridViewGet: async (
      searchString?: string,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Delivery/SearchGridView`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (searchString !== undefined) {
        localVarQueryParameter["SearchString"] = searchString;
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Searches the grid view.
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {ApiDeliverySearchNFilterGridViewPostRequest} [apiDeliverySearchNFilterGridViewPostRequest] The filter and search string requirement.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDeliverySearchNFilterGridViewPost: async (
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      apiDeliverySearchNFilterGridViewPostRequest?: ApiDeliverySearchNFilterGridViewPostRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Delivery/SearchNFilterGridView`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      localVarHeaderParameter["Content-Type"] =
        "application/json;odata.metadata=minimal;odata.streaming=true";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiDeliverySearchNFilterGridViewPostRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary
     * @param {ApiDeliveryDRAFTPatchRequest} [apiDeliveryDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDeliveryUpdatePost: async (
      apiDeliveryDRAFTPatchRequest?: ApiDeliveryDRAFTPatchRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Delivery/Update`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      localVarHeaderParameter["Content-Type"] =
        "application/json;odata.metadata=minimal;odata.streaming=true";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiDeliveryDRAFTPatchRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {number} docEntry
     * @param {boolean} [isDraft]
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    docEntryGet: async (
      docEntry: number,
      isDraft?: boolean,
      $expand?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'docEntry' is not null or undefined
      assertParamExists("docEntryGet", "docEntry", docEntry);
      const localVarPath = `/api/Delivery({DocEntry})`.replace(
        `{${"DocEntry"}}`,
        encodeURIComponent(String(docEntry))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * DeliveryApi - functional programming interface
 * @export
 */
export const DeliveryApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = DeliveryApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {number} docEntry
     * @param {string} dRAFT
     * @param {boolean} [isDraft]
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiDeliveryDRAFTDocEntryGet(
      docEntry: number,
      dRAFT: string,
      isDraft?: boolean,
      $expand?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliveryModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiDeliveryDRAFTDocEntryGet(
          docEntry,
          dRAFT,
          isDraft,
          $expand,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Default action to acquire list of documents by IsDraft
     * @param {string} dRAFT
     * @param {boolean} [isDraft]
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiDeliveryDRAFTGet(
      dRAFT: string,
      isDraft?: boolean,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<DeliveryModelODataResultCollection>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiDeliveryDRAFTGet(
          dRAFT,
          isDraft,
          $top,
          $skip,
          $filter,
          $orderby,
          $expand,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {number} docEntry
     * @param {string} dRAFT
     * @param {boolean} [isDraft]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiDeliveryDRAFTGetFormIdDocEntryGet(
      docEntry: number,
      dRAFT: string,
      isDraft?: boolean,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiDeliveryDRAFTGetFormIdDocEntryGet(
          docEntry,
          dRAFT,
          isDraft,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary
     * @param {string} dRAFT
     * @param {ApiDeliveryDRAFTPatchRequest} [apiDeliveryDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiDeliveryDRAFTPatch(
      dRAFT: string,
      apiDeliveryDRAFTPatchRequest?: ApiDeliveryDRAFTPatchRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliveryModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiDeliveryDRAFTPatch(
          dRAFT,
          apiDeliveryDRAFTPatchRequest,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary
     * @param {string} dRAFT
     * @param {ApiDeliveryDRAFTPatchRequest} [apiDeliveryDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiDeliveryDRAFTUpdatePost(
      dRAFT: string,
      apiDeliveryDRAFTPatchRequest?: ApiDeliveryDRAFTPatchRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliveryModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiDeliveryDRAFTUpdatePost(
          dRAFT,
          apiDeliveryDRAFTPatchRequest,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {number} docEntry
     * @param {boolean} [isDraft]
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiDeliveryDocEntryGet(
      docEntry: number,
      isDraft?: boolean,
      $expand?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliveryModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiDeliveryDocEntryGet(
          docEntry,
          isDraft,
          $expand,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Default action to acquire list of documents by IsDraft
     * @param {boolean} [isDraft]
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiDeliveryGet(
      isDraft?: boolean,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<DeliveryModelODataResultCollection>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeliveryGet(
        isDraft,
        $top,
        $skip,
        $filter,
        $orderby,
        $expand,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Used to provide valid dimensions of Delivery GridView
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiDeliveryGetDocumentFilterDimensionsGet(
      $filter?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<DocumentFilterDimensions>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiDeliveryGetDocumentFilterDimensionsGet(
          $filter,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {number} docEntry
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiDeliveryGetFileUriListDocEntryGet(
      docEntry: number,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<FileUriODataResultCollection>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiDeliveryGetFileUriListDocEntryGet(
          docEntry,
          $top,
          $skip,
          $filter,
          $orderby,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {number} docEntry
     * @param {boolean} [isDraft]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiDeliveryGetFormIdDocEntryGet(
      docEntry: number,
      isDraft?: boolean,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiDeliveryGetFormIdDocEntryGet(
          docEntry,
          isDraft,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary
     * @param {ApiDeliveryDRAFTPatchRequest} [apiDeliveryDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiDeliveryPatch(
      apiDeliveryDRAFTPatchRequest?: ApiDeliveryDRAFTPatchRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliveryModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiDeliveryPatch(
          apiDeliveryDRAFTPatchRequest,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} [searchString]
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiDeliverySearchContractDetailsGet(
      searchString?: string,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<DeliveryModelODataResultCollection>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiDeliverySearchContractDetailsGet(
          searchString,
          $top,
          $skip,
          $filter,
          $orderby,
          $expand,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} [searchString]
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiDeliverySearchGridViewGet(
      searchString?: string,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<DeliveryModelODataResultCollection>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiDeliverySearchGridViewGet(
          searchString,
          $top,
          $skip,
          $filter,
          $orderby,
          $expand,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Searches the grid view.
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {ApiDeliverySearchNFilterGridViewPostRequest} [apiDeliverySearchNFilterGridViewPostRequest] The filter and search string requirement.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiDeliverySearchNFilterGridViewPost(
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      apiDeliverySearchNFilterGridViewPostRequest?: ApiDeliverySearchNFilterGridViewPostRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<DeliveryModelODataResultCollection>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiDeliverySearchNFilterGridViewPost(
          $top,
          $skip,
          $filter,
          $orderby,
          $expand,
          apiDeliverySearchNFilterGridViewPostRequest,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary
     * @param {ApiDeliveryDRAFTPatchRequest} [apiDeliveryDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiDeliveryUpdatePost(
      apiDeliveryDRAFTPatchRequest?: ApiDeliveryDRAFTPatchRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliveryModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiDeliveryUpdatePost(
          apiDeliveryDRAFTPatchRequest,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {number} docEntry
     * @param {boolean} [isDraft]
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async docEntryGet(
      docEntry: number,
      isDraft?: boolean,
      $expand?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliveryModel>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.docEntryGet(
        docEntry,
        isDraft,
        $expand,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * DeliveryApi - factory interface
 * @export
 */
export const DeliveryApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = DeliveryApiFp(configuration);
  return {
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {DeliveryApiApiDeliveryDRAFTDocEntryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDeliveryDRAFTDocEntryGet(
      requestParameters: DeliveryApiApiDeliveryDRAFTDocEntryGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<DeliveryModel> {
      return localVarFp
        .apiDeliveryDRAFTDocEntryGet(
          requestParameters.docEntry,
          requestParameters.dRAFT,
          requestParameters.isDraft,
          requestParameters.$expand,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Default action to acquire list of documents by IsDraft
     * @param {DeliveryApiApiDeliveryDRAFTGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDeliveryDRAFTGet(
      requestParameters: DeliveryApiApiDeliveryDRAFTGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<DeliveryModelODataResultCollection> {
      return localVarFp
        .apiDeliveryDRAFTGet(
          requestParameters.dRAFT,
          requestParameters.isDraft,
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          requestParameters.$expand,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeliveryApiApiDeliveryDRAFTGetFormIdDocEntryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDeliveryDRAFTGetFormIdDocEntryGet(
      requestParameters: DeliveryApiApiDeliveryDRAFTGetFormIdDocEntryGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<number> {
      return localVarFp
        .apiDeliveryDRAFTGetFormIdDocEntryGet(
          requestParameters.docEntry,
          requestParameters.dRAFT,
          requestParameters.isDraft,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary
     * @param {DeliveryApiApiDeliveryDRAFTPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDeliveryDRAFTPatch(
      requestParameters: DeliveryApiApiDeliveryDRAFTPatchRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<DeliveryModel> {
      return localVarFp
        .apiDeliveryDRAFTPatch(
          requestParameters.dRAFT,
          requestParameters.apiDeliveryDRAFTPatchRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary
     * @param {DeliveryApiApiDeliveryDRAFTUpdatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDeliveryDRAFTUpdatePost(
      requestParameters: DeliveryApiApiDeliveryDRAFTUpdatePostRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<DeliveryModel> {
      return localVarFp
        .apiDeliveryDRAFTUpdatePost(
          requestParameters.dRAFT,
          requestParameters.apiDeliveryDRAFTPatchRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {DeliveryApiApiDeliveryDocEntryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDeliveryDocEntryGet(
      requestParameters: DeliveryApiApiDeliveryDocEntryGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<DeliveryModel> {
      return localVarFp
        .apiDeliveryDocEntryGet(
          requestParameters.docEntry,
          requestParameters.isDraft,
          requestParameters.$expand,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Default action to acquire list of documents by IsDraft
     * @param {DeliveryApiApiDeliveryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDeliveryGet(
      requestParameters: DeliveryApiApiDeliveryGetRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<DeliveryModelODataResultCollection> {
      return localVarFp
        .apiDeliveryGet(
          requestParameters.isDraft,
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          requestParameters.$expand,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Used to provide valid dimensions of Delivery GridView
     * @param {DeliveryApiApiDeliveryGetDocumentFilterDimensionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDeliveryGetDocumentFilterDimensionsGet(
      requestParameters: DeliveryApiApiDeliveryGetDocumentFilterDimensionsGetRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<DocumentFilterDimensions> {
      return localVarFp
        .apiDeliveryGetDocumentFilterDimensionsGet(
          requestParameters.$filter,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeliveryApiApiDeliveryGetFileUriListDocEntryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDeliveryGetFileUriListDocEntryGet(
      requestParameters: DeliveryApiApiDeliveryGetFileUriListDocEntryGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<FileUriODataResultCollection> {
      return localVarFp
        .apiDeliveryGetFileUriListDocEntryGet(
          requestParameters.docEntry,
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeliveryApiApiDeliveryGetFormIdDocEntryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDeliveryGetFormIdDocEntryGet(
      requestParameters: DeliveryApiApiDeliveryGetFormIdDocEntryGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<number> {
      return localVarFp
        .apiDeliveryGetFormIdDocEntryGet(
          requestParameters.docEntry,
          requestParameters.isDraft,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary
     * @param {DeliveryApiApiDeliveryPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDeliveryPatch(
      requestParameters: DeliveryApiApiDeliveryPatchRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<DeliveryModel> {
      return localVarFp
        .apiDeliveryPatch(
          requestParameters.apiDeliveryDRAFTPatchRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeliveryApiApiDeliverySearchContractDetailsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDeliverySearchContractDetailsGet(
      requestParameters: DeliveryApiApiDeliverySearchContractDetailsGetRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<DeliveryModelODataResultCollection> {
      return localVarFp
        .apiDeliverySearchContractDetailsGet(
          requestParameters.searchString,
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          requestParameters.$expand,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeliveryApiApiDeliverySearchGridViewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDeliverySearchGridViewGet(
      requestParameters: DeliveryApiApiDeliverySearchGridViewGetRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<DeliveryModelODataResultCollection> {
      return localVarFp
        .apiDeliverySearchGridViewGet(
          requestParameters.searchString,
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          requestParameters.$expand,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Searches the grid view.
     * @param {DeliveryApiApiDeliverySearchNFilterGridViewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDeliverySearchNFilterGridViewPost(
      requestParameters: DeliveryApiApiDeliverySearchNFilterGridViewPostRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<DeliveryModelODataResultCollection> {
      return localVarFp
        .apiDeliverySearchNFilterGridViewPost(
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          requestParameters.$expand,
          requestParameters.apiDeliverySearchNFilterGridViewPostRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary
     * @param {DeliveryApiApiDeliveryUpdatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDeliveryUpdatePost(
      requestParameters: DeliveryApiApiDeliveryUpdatePostRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<DeliveryModel> {
      return localVarFp
        .apiDeliveryUpdatePost(
          requestParameters.apiDeliveryDRAFTPatchRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {DeliveryApiDocEntryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    docEntryGet(
      requestParameters: DeliveryApiDocEntryGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<DeliveryModel> {
      return localVarFp
        .docEntryGet(
          requestParameters.docEntry,
          requestParameters.isDraft,
          requestParameters.$expand,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for apiDeliveryDRAFTDocEntryGet operation in DeliveryApi.
 * @export
 * @interface DeliveryApiApiDeliveryDRAFTDocEntryGetRequest
 */
export interface DeliveryApiApiDeliveryDRAFTDocEntryGetRequest {
  /**
   *
   * @type {number}
   * @memberof DeliveryApiApiDeliveryDRAFTDocEntryGet
   */
  readonly docEntry: number;

  /**
   *
   * @type {string}
   * @memberof DeliveryApiApiDeliveryDRAFTDocEntryGet
   */
  readonly dRAFT: string;

  /**
   *
   * @type {boolean}
   * @memberof DeliveryApiApiDeliveryDRAFTDocEntryGet
   */
  readonly isDraft?: boolean;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof DeliveryApiApiDeliveryDRAFTDocEntryGet
   */
  readonly $expand?: string;
}

/**
 * Request parameters for apiDeliveryDRAFTGet operation in DeliveryApi.
 * @export
 * @interface DeliveryApiApiDeliveryDRAFTGetRequest
 */
export interface DeliveryApiApiDeliveryDRAFTGetRequest {
  /**
   *
   * @type {string}
   * @memberof DeliveryApiApiDeliveryDRAFTGet
   */
  readonly dRAFT: string;

  /**
   *
   * @type {boolean}
   * @memberof DeliveryApiApiDeliveryDRAFTGet
   */
  readonly isDraft?: boolean;

  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof DeliveryApiApiDeliveryDRAFTGet
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof DeliveryApiApiDeliveryDRAFTGet
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof DeliveryApiApiDeliveryDRAFTGet
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof DeliveryApiApiDeliveryDRAFTGet
   */
  readonly $orderby?: string;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof DeliveryApiApiDeliveryDRAFTGet
   */
  readonly $expand?: string;
}

/**
 * Request parameters for apiDeliveryDRAFTGetFormIdDocEntryGet operation in DeliveryApi.
 * @export
 * @interface DeliveryApiApiDeliveryDRAFTGetFormIdDocEntryGetRequest
 */
export interface DeliveryApiApiDeliveryDRAFTGetFormIdDocEntryGetRequest {
  /**
   *
   * @type {number}
   * @memberof DeliveryApiApiDeliveryDRAFTGetFormIdDocEntryGet
   */
  readonly docEntry: number;

  /**
   *
   * @type {string}
   * @memberof DeliveryApiApiDeliveryDRAFTGetFormIdDocEntryGet
   */
  readonly dRAFT: string;

  /**
   *
   * @type {boolean}
   * @memberof DeliveryApiApiDeliveryDRAFTGetFormIdDocEntryGet
   */
  readonly isDraft?: boolean;
}

/**
 * Request parameters for apiDeliveryDRAFTPatch operation in DeliveryApi.
 * @export
 * @interface DeliveryApiApiDeliveryDRAFTPatchRequest
 */
export interface DeliveryApiApiDeliveryDRAFTPatchRequest {
  /**
   *
   * @type {string}
   * @memberof DeliveryApiApiDeliveryDRAFTPatch
   */
  readonly dRAFT: string;

  /**
   *
   * @type {ApiDeliveryDRAFTPatchRequest}
   * @memberof DeliveryApiApiDeliveryDRAFTPatch
   */
  readonly apiDeliveryDRAFTPatchRequest?: ApiDeliveryDRAFTPatchRequest;
}

/**
 * Request parameters for apiDeliveryDRAFTUpdatePost operation in DeliveryApi.
 * @export
 * @interface DeliveryApiApiDeliveryDRAFTUpdatePostRequest
 */
export interface DeliveryApiApiDeliveryDRAFTUpdatePostRequest {
  /**
   *
   * @type {string}
   * @memberof DeliveryApiApiDeliveryDRAFTUpdatePost
   */
  readonly dRAFT: string;

  /**
   *
   * @type {ApiDeliveryDRAFTPatchRequest}
   * @memberof DeliveryApiApiDeliveryDRAFTUpdatePost
   */
  readonly apiDeliveryDRAFTPatchRequest?: ApiDeliveryDRAFTPatchRequest;
}

/**
 * Request parameters for apiDeliveryDocEntryGet operation in DeliveryApi.
 * @export
 * @interface DeliveryApiApiDeliveryDocEntryGetRequest
 */
export interface DeliveryApiApiDeliveryDocEntryGetRequest {
  /**
   *
   * @type {number}
   * @memberof DeliveryApiApiDeliveryDocEntryGet
   */
  readonly docEntry: number;

  /**
   *
   * @type {boolean}
   * @memberof DeliveryApiApiDeliveryDocEntryGet
   */
  readonly isDraft?: boolean;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof DeliveryApiApiDeliveryDocEntryGet
   */
  readonly $expand?: string;
}

/**
 * Request parameters for apiDeliveryGet operation in DeliveryApi.
 * @export
 * @interface DeliveryApiApiDeliveryGetRequest
 */
export interface DeliveryApiApiDeliveryGetRequest {
  /**
   *
   * @type {boolean}
   * @memberof DeliveryApiApiDeliveryGet
   */
  readonly isDraft?: boolean;

  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof DeliveryApiApiDeliveryGet
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof DeliveryApiApiDeliveryGet
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof DeliveryApiApiDeliveryGet
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof DeliveryApiApiDeliveryGet
   */
  readonly $orderby?: string;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof DeliveryApiApiDeliveryGet
   */
  readonly $expand?: string;
}

/**
 * Request parameters for apiDeliveryGetDocumentFilterDimensionsGet operation in DeliveryApi.
 * @export
 * @interface DeliveryApiApiDeliveryGetDocumentFilterDimensionsGetRequest
 */
export interface DeliveryApiApiDeliveryGetDocumentFilterDimensionsGetRequest {
  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof DeliveryApiApiDeliveryGetDocumentFilterDimensionsGet
   */
  readonly $filter?: string;
}

/**
 * Request parameters for apiDeliveryGetFileUriListDocEntryGet operation in DeliveryApi.
 * @export
 * @interface DeliveryApiApiDeliveryGetFileUriListDocEntryGetRequest
 */
export interface DeliveryApiApiDeliveryGetFileUriListDocEntryGetRequest {
  /**
   *
   * @type {number}
   * @memberof DeliveryApiApiDeliveryGetFileUriListDocEntryGet
   */
  readonly docEntry: number;

  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof DeliveryApiApiDeliveryGetFileUriListDocEntryGet
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof DeliveryApiApiDeliveryGetFileUriListDocEntryGet
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof DeliveryApiApiDeliveryGetFileUriListDocEntryGet
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof DeliveryApiApiDeliveryGetFileUriListDocEntryGet
   */
  readonly $orderby?: string;
}

/**
 * Request parameters for apiDeliveryGetFormIdDocEntryGet operation in DeliveryApi.
 * @export
 * @interface DeliveryApiApiDeliveryGetFormIdDocEntryGetRequest
 */
export interface DeliveryApiApiDeliveryGetFormIdDocEntryGetRequest {
  /**
   *
   * @type {number}
   * @memberof DeliveryApiApiDeliveryGetFormIdDocEntryGet
   */
  readonly docEntry: number;

  /**
   *
   * @type {boolean}
   * @memberof DeliveryApiApiDeliveryGetFormIdDocEntryGet
   */
  readonly isDraft?: boolean;
}

/**
 * Request parameters for apiDeliveryPatch operation in DeliveryApi.
 * @export
 * @interface DeliveryApiApiDeliveryPatchRequest
 */
export interface DeliveryApiApiDeliveryPatchRequest {
  /**
   *
   * @type {ApiDeliveryDRAFTPatchRequest}
   * @memberof DeliveryApiApiDeliveryPatch
   */
  readonly apiDeliveryDRAFTPatchRequest?: ApiDeliveryDRAFTPatchRequest;
}

/**
 * Request parameters for apiDeliverySearchContractDetailsGet operation in DeliveryApi.
 * @export
 * @interface DeliveryApiApiDeliverySearchContractDetailsGetRequest
 */
export interface DeliveryApiApiDeliverySearchContractDetailsGetRequest {
  /**
   *
   * @type {string}
   * @memberof DeliveryApiApiDeliverySearchContractDetailsGet
   */
  readonly searchString?: string;

  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof DeliveryApiApiDeliverySearchContractDetailsGet
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof DeliveryApiApiDeliverySearchContractDetailsGet
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof DeliveryApiApiDeliverySearchContractDetailsGet
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof DeliveryApiApiDeliverySearchContractDetailsGet
   */
  readonly $orderby?: string;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof DeliveryApiApiDeliverySearchContractDetailsGet
   */
  readonly $expand?: string;
}

/**
 * Request parameters for apiDeliverySearchGridViewGet operation in DeliveryApi.
 * @export
 * @interface DeliveryApiApiDeliverySearchGridViewGetRequest
 */
export interface DeliveryApiApiDeliverySearchGridViewGetRequest {
  /**
   *
   * @type {string}
   * @memberof DeliveryApiApiDeliverySearchGridViewGet
   */
  readonly searchString?: string;

  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof DeliveryApiApiDeliverySearchGridViewGet
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof DeliveryApiApiDeliverySearchGridViewGet
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof DeliveryApiApiDeliverySearchGridViewGet
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof DeliveryApiApiDeliverySearchGridViewGet
   */
  readonly $orderby?: string;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof DeliveryApiApiDeliverySearchGridViewGet
   */
  readonly $expand?: string;
}

/**
 * Request parameters for apiDeliverySearchNFilterGridViewPost operation in DeliveryApi.
 * @export
 * @interface DeliveryApiApiDeliverySearchNFilterGridViewPostRequest
 */
export interface DeliveryApiApiDeliverySearchNFilterGridViewPostRequest {
  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof DeliveryApiApiDeliverySearchNFilterGridViewPost
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof DeliveryApiApiDeliverySearchNFilterGridViewPost
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof DeliveryApiApiDeliverySearchNFilterGridViewPost
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof DeliveryApiApiDeliverySearchNFilterGridViewPost
   */
  readonly $orderby?: string;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof DeliveryApiApiDeliverySearchNFilterGridViewPost
   */
  readonly $expand?: string;

  /**
   * The filter and search string requirement.
   * @type {ApiDeliverySearchNFilterGridViewPostRequest}
   * @memberof DeliveryApiApiDeliverySearchNFilterGridViewPost
   */
  readonly apiDeliverySearchNFilterGridViewPostRequest?: ApiDeliverySearchNFilterGridViewPostRequest;
}

/**
 * Request parameters for apiDeliveryUpdatePost operation in DeliveryApi.
 * @export
 * @interface DeliveryApiApiDeliveryUpdatePostRequest
 */
export interface DeliveryApiApiDeliveryUpdatePostRequest {
  /**
   *
   * @type {ApiDeliveryDRAFTPatchRequest}
   * @memberof DeliveryApiApiDeliveryUpdatePost
   */
  readonly apiDeliveryDRAFTPatchRequest?: ApiDeliveryDRAFTPatchRequest;
}

/**
 * Request parameters for docEntryGet operation in DeliveryApi.
 * @export
 * @interface DeliveryApiDocEntryGetRequest
 */
export interface DeliveryApiDocEntryGetRequest {
  /**
   *
   * @type {number}
   * @memberof DeliveryApiDocEntryGet
   */
  readonly docEntry: number;

  /**
   *
   * @type {boolean}
   * @memberof DeliveryApiDocEntryGet
   */
  readonly isDraft?: boolean;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof DeliveryApiDocEntryGet
   */
  readonly $expand?: string;
}

/**
 * DeliveryApi - object-oriented interface
 * @export
 * @class DeliveryApi
 * @extends {BaseAPI}
 */
export class DeliveryApi extends BaseAPI {
  /**
   *
   * @summary Get document by DocEntry and IsDraft
   * @param {DeliveryApiApiDeliveryDRAFTDocEntryGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryApi
   */
  public apiDeliveryDRAFTDocEntryGet(
    requestParameters: DeliveryApiApiDeliveryDRAFTDocEntryGetRequest,
    options?: AxiosRequestConfig
  ) {
    return DeliveryApiFp(this.configuration)
      .apiDeliveryDRAFTDocEntryGet(
        requestParameters.docEntry,
        requestParameters.dRAFT,
        requestParameters.isDraft,
        requestParameters.$expand,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Default action to acquire list of documents by IsDraft
   * @param {DeliveryApiApiDeliveryDRAFTGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryApi
   */
  public apiDeliveryDRAFTGet(
    requestParameters: DeliveryApiApiDeliveryDRAFTGetRequest,
    options?: AxiosRequestConfig
  ) {
    return DeliveryApiFp(this.configuration)
      .apiDeliveryDRAFTGet(
        requestParameters.dRAFT,
        requestParameters.isDraft,
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        requestParameters.$expand,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeliveryApiApiDeliveryDRAFTGetFormIdDocEntryGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryApi
   */
  public apiDeliveryDRAFTGetFormIdDocEntryGet(
    requestParameters: DeliveryApiApiDeliveryDRAFTGetFormIdDocEntryGetRequest,
    options?: AxiosRequestConfig
  ) {
    return DeliveryApiFp(this.configuration)
      .apiDeliveryDRAFTGetFormIdDocEntryGet(
        requestParameters.docEntry,
        requestParameters.dRAFT,
        requestParameters.isDraft,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary
   * @param {DeliveryApiApiDeliveryDRAFTPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryApi
   */
  public apiDeliveryDRAFTPatch(
    requestParameters: DeliveryApiApiDeliveryDRAFTPatchRequest,
    options?: AxiosRequestConfig
  ) {
    return DeliveryApiFp(this.configuration)
      .apiDeliveryDRAFTPatch(
        requestParameters.dRAFT,
        requestParameters.apiDeliveryDRAFTPatchRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary
   * @param {DeliveryApiApiDeliveryDRAFTUpdatePostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryApi
   */
  public apiDeliveryDRAFTUpdatePost(
    requestParameters: DeliveryApiApiDeliveryDRAFTUpdatePostRequest,
    options?: AxiosRequestConfig
  ) {
    return DeliveryApiFp(this.configuration)
      .apiDeliveryDRAFTUpdatePost(
        requestParameters.dRAFT,
        requestParameters.apiDeliveryDRAFTPatchRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get document by DocEntry and IsDraft
   * @param {DeliveryApiApiDeliveryDocEntryGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryApi
   */
  public apiDeliveryDocEntryGet(
    requestParameters: DeliveryApiApiDeliveryDocEntryGetRequest,
    options?: AxiosRequestConfig
  ) {
    return DeliveryApiFp(this.configuration)
      .apiDeliveryDocEntryGet(
        requestParameters.docEntry,
        requestParameters.isDraft,
        requestParameters.$expand,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Default action to acquire list of documents by IsDraft
   * @param {DeliveryApiApiDeliveryGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryApi
   */
  public apiDeliveryGet(
    requestParameters: DeliveryApiApiDeliveryGetRequest = {},
    options?: AxiosRequestConfig
  ) {
    return DeliveryApiFp(this.configuration)
      .apiDeliveryGet(
        requestParameters.isDraft,
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        requestParameters.$expand,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Used to provide valid dimensions of Delivery GridView
   * @param {DeliveryApiApiDeliveryGetDocumentFilterDimensionsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryApi
   */
  public apiDeliveryGetDocumentFilterDimensionsGet(
    requestParameters: DeliveryApiApiDeliveryGetDocumentFilterDimensionsGetRequest = {},
    options?: AxiosRequestConfig
  ) {
    return DeliveryApiFp(this.configuration)
      .apiDeliveryGetDocumentFilterDimensionsGet(
        requestParameters.$filter,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeliveryApiApiDeliveryGetFileUriListDocEntryGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryApi
   */
  public apiDeliveryGetFileUriListDocEntryGet(
    requestParameters: DeliveryApiApiDeliveryGetFileUriListDocEntryGetRequest,
    options?: AxiosRequestConfig
  ) {
    return DeliveryApiFp(this.configuration)
      .apiDeliveryGetFileUriListDocEntryGet(
        requestParameters.docEntry,
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeliveryApiApiDeliveryGetFormIdDocEntryGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryApi
   */
  public apiDeliveryGetFormIdDocEntryGet(
    requestParameters: DeliveryApiApiDeliveryGetFormIdDocEntryGetRequest,
    options?: AxiosRequestConfig
  ) {
    return DeliveryApiFp(this.configuration)
      .apiDeliveryGetFormIdDocEntryGet(
        requestParameters.docEntry,
        requestParameters.isDraft,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary
   * @param {DeliveryApiApiDeliveryPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryApi
   */
  public apiDeliveryPatch(
    requestParameters: DeliveryApiApiDeliveryPatchRequest = {},
    options?: AxiosRequestConfig
  ) {
    return DeliveryApiFp(this.configuration)
      .apiDeliveryPatch(requestParameters.apiDeliveryDRAFTPatchRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeliveryApiApiDeliverySearchContractDetailsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryApi
   */
  public apiDeliverySearchContractDetailsGet(
    requestParameters: DeliveryApiApiDeliverySearchContractDetailsGetRequest = {},
    options?: AxiosRequestConfig
  ) {
    return DeliveryApiFp(this.configuration)
      .apiDeliverySearchContractDetailsGet(
        requestParameters.searchString,
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        requestParameters.$expand,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeliveryApiApiDeliverySearchGridViewGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryApi
   */
  public apiDeliverySearchGridViewGet(
    requestParameters: DeliveryApiApiDeliverySearchGridViewGetRequest = {},
    options?: AxiosRequestConfig
  ) {
    return DeliveryApiFp(this.configuration)
      .apiDeliverySearchGridViewGet(
        requestParameters.searchString,
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        requestParameters.$expand,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Searches the grid view.
   * @param {DeliveryApiApiDeliverySearchNFilterGridViewPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryApi
   */
  public apiDeliverySearchNFilterGridViewPost(
    requestParameters: DeliveryApiApiDeliverySearchNFilterGridViewPostRequest = {},
    options?: AxiosRequestConfig
  ) {
    return DeliveryApiFp(this.configuration)
      .apiDeliverySearchNFilterGridViewPost(
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        requestParameters.$expand,
        requestParameters.apiDeliverySearchNFilterGridViewPostRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary
   * @param {DeliveryApiApiDeliveryUpdatePostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryApi
   */
  public apiDeliveryUpdatePost(
    requestParameters: DeliveryApiApiDeliveryUpdatePostRequest = {},
    options?: AxiosRequestConfig
  ) {
    return DeliveryApiFp(this.configuration)
      .apiDeliveryUpdatePost(
        requestParameters.apiDeliveryDRAFTPatchRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get document by DocEntry and IsDraft
   * @param {DeliveryApiDocEntryGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryApi
   */
  public docEntryGet(
    requestParameters: DeliveryApiDocEntryGetRequest,
    options?: AxiosRequestConfig
  ) {
    return DeliveryApiFp(this.configuration)
      .docEntryGet(
        requestParameters.docEntry,
        requestParameters.isDraft,
        requestParameters.$expand,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
